/**
 * Copyright © Binary Anvil, Inc. All rights reserved.
 * See https://binaryanvil.com/software/license for license details.
 */
import React, {ReactNode, useCallback} from "react";
import {CmsBlock, useGetCmsBlocksLazyQuery} from "@/generated/graphql";
import {useSnackbar} from "notistack";
import jsonToJsx from "@/app/utils/jsonToJsx";

/**
 * Connector for getting CMS block data
 */
const useGetCmsBlock = (skeleton?:ReactNode) => {
    const [getCmsBlockQueryHandler, {data, loading, error}] = useGetCmsBlocksLazyQuery();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const getCmsBlockTrigger = useCallback((identifiers:string) => {
        getCmsBlockQueryHandler({
            variables: {
                identifiers: identifiers
            }
        }).catch((reason) => {
            console.error(reason);
            enqueueSnackbar('Error getting CMS block', {variant: "error"});
        });
    }, []);

    let cmsBlockContent = skeleton ?? <></>;
    let cmsBlockData:CmsBlock = {};

    if(!loading && ! error) {
        if(data && data.cmsBlocks && data.cmsBlocks.items && data.cmsBlocks.items[0]) {
            const json = data.cmsBlocks.items[0].content_json ?? data.cmsBlocks.items[0].content ?? '{}';
            cmsBlockContent = jsonToJsx(json);
            cmsBlockData = data.cmsBlocks.items[0];
        }
    }

    return {getCmsBlockTrigger, loading, cmsBlockContent, cmsBlockData};
}

export default useGetCmsBlock;